import ResultField from "@/components/Calculator/Components/ResultField/resultField.component";
import ResultTitle from "@/components/Calculator/Components/ResultTitle/resultTitle.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    cementplateArea: number;
    cementplateVolume: number;
    mailParams: any;
};

const Result = ({ cementplateArea, cementplateVolume, mailParams }: Props) => {
    const { t } = useGranite();

    const cementInKg = Number(cementplateVolume * 350);
    const gravelInKg = Number(cementplateVolume * 1000);
    const sandInKg = Number(cementplateVolume * 800);
    const waterInLiters = Number(cementplateVolume * 175);
    const cementInBagsOf20Kg = Number(Math.ceil(cementInKg / 20));
    const cementInBagsOf25Kg = Number(Math.ceil(cementInKg / 25));
    const gravelInBagsOf20Kg = Number(Math.ceil(gravelInKg / 20));
    const gravelInBagsOf25Kg = Number(Math.ceil(gravelInKg / 25));
    const sandInBagsOf20Kg = Number(Math.ceil(sandInKg / 20));
    const sandInBagsOf25Kg = Number(Math.ceil(sandInKg / 25));

    return (
        <div className={"mt-4"}>
            <ResultTitle mailParams={mailParams} />
            <Row>
                <ResultField
                    copy={t("calculator.cementplateCalculator.cementplateArea")}
                    value={cementplateArea.toFixed(2)}
                    sm={6}
                    lg={3}
                    unit={"m"}
                    sup={2}
                />
                <ResultField
                    copy={t(
                        "calculator.cementplateCalculator.cementplateVolume"
                    )}
                    value={cementplateVolume.toFixed(2)}
                    sm={6}
                    lg={3}
                    unit={"m"}
                    sup={3}
                />
            </Row>
            <Row>
                <Col>
                    <h4 className="d-sm-block">
                        {t("calculator.volumeNeeded")}
                    </h4>
                </Col>
            </Row>
            <Row className={"calculator-group"}>
                <ResultField
                    sm={6}
                    lg={3}
                    copy={t("calculator.cement")}
                    value={cementInKg.toFixed(0)}
                    unit={"kg"}
                />
                <ResultField
                    sm={6}
                    lg={3}
                    copy={t("calculator.nrBags20Kg")}
                    value={cementInBagsOf20Kg.toFixed(0)}
                />
                <ResultField
                    className={"offset-sm-6 offset-lg-0"}
                    sm={6}
                    lg={3}
                    copy={t("calculator.nrBags25Kg")}
                    value={cementInBagsOf25Kg.toFixed(0)}
                />
            </Row>
            <Row className={"calculator-group"}>
                <ResultField
                    sm={6}
                    lg={3}
                    copy={t("calculator.gravel")}
                    value={gravelInKg.toFixed(0)}
                    unit={"kg"}
                />
                <ResultField
                    sm={6}
                    lg={3}
                    copy={t("calculator.nrBags20Kg")}
                    value={gravelInBagsOf20Kg.toFixed(0)}
                />
                <ResultField
                    className={"offset-sm-6 offset-lg-0"}
                    sm={6}
                    lg={3}
                    copy={t("calculator.nrBags25Kg")}
                    value={gravelInBagsOf25Kg.toFixed(0)}
                />
            </Row>
            <Row className={"calculator-group"}>
                <ResultField
                    sm={6}
                    lg={3}
                    copy={t("calculator.rhineSand")}
                    value={sandInKg.toFixed(0)}
                    unit={"kg"}
                />
                <ResultField
                    sm={6}
                    lg={3}
                    copy={t("calculator.nrBags20Kg")}
                    value={sandInBagsOf20Kg.toFixed(0)}
                />
                <ResultField
                    className={"offset-sm-6 offset-lg-0"}
                    sm={6}
                    lg={3}
                    copy={t("calculator.nrBags25Kg")}
                    value={sandInBagsOf25Kg.toFixed(0)}
                />
            </Row>
            <Row>
                <ResultField
                    sm={6}
                    lg={3}
                    copy={t("calculator.water")}
                    value={waterInLiters.toFixed(0)}
                    unit={"l"}
                />
            </Row>
        </div>
    );
};

export default Result;
